import type { EmailDefaults } from './emailDefaults360';

export interface MinimalEmailDefaultsParams {
    language: string;
    cycleName: string;
    milestoneTitle: string;
}

type MinimalTemplateBuilder = (params: MinimalEmailDefaultsParams) => EmailDefaults;

const MINIMAL_TEMPLATE_BY_LANGUAGE: Record<string, MinimalTemplateBuilder> = {
    en: ({ cycleName, milestoneTitle }) => ({
        title: `${cycleName} — ${milestoneTitle}`,
        body: `<p>This is an update about <strong>${cycleName}</strong>.</p>`,
    }),
    fr: ({ cycleName, milestoneTitle }) => ({
        title: `${cycleName} — ${milestoneTitle}`,
        body: `<p>Voici une mise à jour concernant <strong>${cycleName}</strong>.</p>`,
    }),
    fr_FR: ({ cycleName, milestoneTitle }) => ({
        title: `${cycleName} — ${milestoneTitle}`,
        body: `<p>Voici une mise à jour concernant <strong>${cycleName}</strong>.</p>`,
    }),
};

export const getMinimalEmailDefaults = (params: MinimalEmailDefaultsParams): EmailDefaults => {
    const builder =
        MINIMAL_TEMPLATE_BY_LANGUAGE[params.language] ?? MINIMAL_TEMPLATE_BY_LANGUAGE.en;

    return builder(params);
};
